"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormularioCabecalho = void 0;
var estiloFormularioCabecalho = require('./FormularioCabecalho.module.scss');
var react_1 = __importDefault(require("react"));
var FormularioCabecalho = function (_a) {
    var children = _a.children, style = _a.style;
    return (react_1.default.createElement("div", { className: estiloFormularioCabecalho.formularioCabecalho, style: style }, children));
};
exports.FormularioCabecalho = FormularioCabecalho;
